export default "__VITE_PUBLIC_ASSET__6f6868ca__"